import { css, Global } from '@emotion/react'

import 'sanitize.css'
import 'sanitize.css/forms.css'
import 'sanitize.css/typography.css'

import { useReactiveVar } from '../utils/reactiveVar'
import { isModalOpenVar } from './QuickHelpModal'
import theme from '../themes/theme'

const GlobalStyles = () => {
  const isModalOpen = useReactiveVar(isModalOpenVar)
  return (
    <>
      {/* Ensure the fonts are applied within the head to prevent the move of style elements from body->Head (Emotion) not to cause any issues */}
      <style jsx global>{`
        body {
          font-family: ${theme.fonts.inter.style.fontFamily}, sans-serif;
        }

        h1,
        h2,
        h3,
        h4,
        h5 {
          font-family: ${theme.fonts.raleway.style.fontFamily}, sans-serif;
        }
      `}</style>
      <Global
        styles={(theme) => [
          css`
            html {
              scroll-padding-top: ${theme.spacing.navigationHeight.mobile}px;

              @media screen and (min-width: ${theme.breakpoints.desktop}px) {
                scroll-padding-top: ${theme.spacing.navigationHeight.desktop}px;
              }
            }
            body {
              font-family: ${theme.fonts.inter.style.fontFamily}, sans-serif;
              font-size: 14px;
              line-height: 1.5;
              color: ${theme.colors.neutral4};
              background: ${theme.colors.primaryPurpleDark};
              overflow: ${isModalOpen ? 'hidden' : 'auto'};

              @media screen and (min-width: ${theme.breakpoints.tablet}px) {
                font-size: 16px;
              }
            }
          `,
          css`
            h1,
            h2,
            h3,
            h4,
            h5 {
              ${theme.text.headings(theme)}
            }
          `,

          css`
            p {
              margin: ${theme.spacing.x2}px 0;
            }
          `,

          // When the image is an exact fit, this does nothing. When the image
          // aspect ratio mismatches, this will fit to fill without distortion.
          // Wanting distortion or empty space instead is super rare, so this is a
          // better default.
          css`
            img {
              object-fit: cover;
            }
          `,

          css`
            a {
              color: ${theme.colors.primaryPurple};
              text-decoration: none;

              :hover {
                text-decoration: underline;
              }
            }
          `,
          css`
            svg {
              height: 1.2em;
              vertical-align: text-bottom;
            }
          `,
          css`
            hr {
              border: 0;
              border-top: 1px solid ${theme.colors.neutral2};
              margin: ${theme.spacing.x2}px 0;
            }
          `,
        ]}
      />
    </>
  )
}

export default GlobalStyles
